import React, { Fragment, useState, useRef } from 'react';
import { COPY_OUT, FACEBOOK_SVG, EMAIL_SVG, COPY_SVG, COPY_SUCCESS, ERROR_MESSAGE } from '../staticTypes'
import { trackSharePop, sendRefEmail } from '../../Utils/blogs'

const icon = (copyFlag) => {
	if (copyFlag) {
		return (
			COPY_SUCCESS
		)
	} else {
		return (
			COPY_SVG
		)

	}
}

const HomeRef = (props) => {
	const { emailShareUrl, facebookShareUrl, shareLink, email, visitorId } = props;
	const inputRef = useRef(null);
	const EmailRef = useRef(null);
	const [copyFlag, setCopyFlay] = useState(false);
	const [myEmail, setMyEmail] = useState(email);
	const [emailResult, setEmailResult] = useState('')
	const [clickEmail, setClickEmail]  = useState(false);


	const copy = (e) => {
		inputRef.current.select();
		document.execCommand("copy");
		setCopyFlay(true);

		trackSharePop(email, visitorId, 'referral-copy-link');

		setTimeout(() => {
			setCopyFlay(false)
		}, COPY_OUT)

		return false;
	}
	const onEmail = (e) => {
		trackSharePop(email, visitorId, 'share-email');
		setClickEmail(!clickEmail);
	}
	const onFb = () => {
		trackSharePop(email, visitorId, 'share-facebook');
	}
	const changeEmail = (e) => {
		setMyEmail(e.target.value)
	}
	const sendEmail = () => {
		trackSharePop(email, visitorId, 'customer-send-email');
		sendRefEmail(email)
		.then((res)=> {
			if(res.code === 200){
				setEmailResult(`The referral email has been sent to your email account ${myEmail}. Please check your email and simply forward the email to your friends!`)
			}else{
				setEmailResult(ERROR_MESSAGE)
			}
		}).catch((err) => {
			console.log(err)
		})
	}
	return (
		<Fragment>
			<div>
				<meta property="og:image" content="https://cdn.shopify.com/s/files/1/2152/3677/files/Banner_Camping_1200x.jpg?v=1594712442"></meta>
			</div>
			<span>
				<div className="copy-text-container referral">
					<input ref={inputRef} readOnly className="text-input with-system-btn referral-url" tabIndex="-1" value={shareLink} />
					<button
						className="system-btn copy" aria-label="Copy referral code"
						onClick={copy}
					>
						{icon(copyFlag)}
					</button>
				</div>
				<div className="referral-sharing-options-container">
					<span>
						<a target="_blank" rel="noreferrer" href={`http://www.facebook.com/sharer.php?u=${encodeURIComponent((facebookShareUrl))}&t=${encodeURIComponent('测试测试')}`} onClick={onFb}>
							<button className="referral-sharing-option" aria-label="Share on facebook">
								<div className="sharing-option-image facebook">
									{ FACEBOOK_SVG }
								</div>
								<div className="sharing-option-name caption text-capitalize">facebook</div>
							</button>
						</a>
					</span>

					{/* <span>
						<a target="_blank"  href={insShareUrl} onClick={onIns}>
							<button className="referral-sharing-option" aria-label="Share on instagram">
								<div className="sharing-option-image instagram">
								{INSTAGRAM_SVG}
								</div>
								<div className="sharing-option-name caption text-capitalize">Instagram</div>
							</button>
						</a>
					</span> */}
					{/* <span>
						<div onClick={onEmail}>
							<button className="referral-sharing-option" aria-label="Share on email">
								<div className="sharing-option-image email">
								{EMAIL_SVG}
								</div>
								<div className="sharing-option-name caption text-capitalize">Email</div>
							</button>
						</div>
					</span> */}
				</div>
				{
					 
					<div className={`to-email ${clickEmail === false ? 'hide': 'true'}`}>
						<div className={`copy-text-container my-email ${emailResult !== ''? 'hide': 'show'}`}>
							<input ref={EmailRef} className="text-input with-system-btn referral-url" tabIndex="-1" onChange={changeEmail} value={myEmail} placeholder="Please enter your email" />
							<button className="system-btn send-email" aria-label="Send email" onClick={ sendEmail }>
								send
							</button>
						</div>
						<p className="email-result">
							{ emailResult }
						</p>
					</div>
				}
				
			</span>
		</Fragment>
	);
}

export default HomeRef;